import { useState } from "react";

import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import { Navbar } from "react-bootstrap";
import { Form, Button } from "react-bootstrap";
import { endPoints } from "../../constant/Environment";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import { addData } from "../../Utility/API";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const HandleSubmit = async () => {
    //     let data = {
    //       login: email,
    //       passwd: password,
    //     };
    //     if (email && password) {
    //       let url = `${endPoints.api.LOGIN_ENDPOINT}`;
    //       await addData(url, data)
    //         .then((response) => {
    //           console.log("data", response.data);
    //           if (response.data.status === "success") {
    //             dispatch({
    //               type: Actions.LOGIN,
    //               data: { user: response.data },
    //             });
    //             navigate("/Home");
    //           } else {
    //             alert(response.data.message);
    //           }
    //         })
    //         .catch((error) => {
    //           console.error(error);
    //         });
    //     }
  };

  return (
    <div>
      <section className="login-page-section">
        <div className="login-form-div">
          <Form className="login-form">
            <h2 className="mb-4">Reset Password</h2>

            <Form.Group className="mb-3 password-box" controlId="PASSWORD">
              <Form.Control
                placeholder="Password"
                type={passwordShow ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div
                className="show-icon"
                onClick={() => {
                  setPasswordShow(!passwordShow);
                }}
              >
                <AiFillEyeInvisible />
              </div>
            </Form.Group>
            <Form.Group className="mb-3 password-box" controlId="PASSWORD">
              <Form.Control
                placeholder="Confirm Password"
                type={confirmPasswordShow ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <div
                className="show-icon"
                onClick={() => {
                  setConfirmPasswordShow(!confirmPasswordShow);
                }}
              >
                <AiFillEyeInvisible />
              </div>
            </Form.Group>

            <div className="login-btn-last  mt-5">
              <Button
                className="reset-btn-form"
                variant="primary"
                onClick={HandleSubmit}
              >
                Submit
              </Button>
            </div>
          </Form>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
